import React from 'react'
import { DocumentChange } from '../shared/interfaces/project/document/changes/document-change.interface'
import { Revision } from '../shared/interfaces/project/document/revision/revision.interface'
import SecondaryChangePageOverlaySimple from './secondary-change-page-overlay-simple'

interface SecondaryPageOverlaySimpleControllerProps {
  pages: number[]
  revisionSelected?: Revision | null
  documentChangeSelected?: DocumentChange | null
}

const SecondaryChangePageOverlaySimpleController: React.FC<
  SecondaryPageOverlaySimpleControllerProps
> = (props) => {
  return (
    <>
      {props.pages.map((page) => (
        <SecondaryChangePageOverlaySimple
          key={page}
          documentChangeSelected={props.documentChangeSelected ?? undefined}
          page={page}
        />
      ))}
    </>
  )
}

export default SecondaryChangePageOverlaySimpleController
